import {initInputStateSwitch} from "./input.state-switch";
import {initGetAjaxForm} from "./.get-ajax-form";
import {initAHrefLightbox} from "./a[href*='#lightbox']";
import {initDivMap} from "./div.map";
import {initYagaLinks} from './[data-click-yaga]';
import {initYagaButtons} from './[data-yaga]';
import {initCookie} from "./cookie";
import {initBanner} from "./div.banner";
import {initPlayer} from "./player/player";
import { videoHover } from "./videoHover";


export const initElements = () => {
	initInputStateSwitch();
	initGetAjaxForm();
	initAHrefLightbox();
	initDivMap();
	initYagaLinks();
	initYagaButtons();
	initCookie();
	initBanner();
	initPlayer();
	videoHover();
};
